var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle53DError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 52",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M44.728 28.922a2.5 2.5 0 0 0 2.274-2.49v-5.434a2.5 2.5 0 0 0-2.274-2.49l-6-.545a2.5 2.5 0 0 0-2.726 2.49v6.525a2.5 2.5 0 0 0 2.726 2.49l6-.546Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M46.002 26.977c0 .686-.388 1.314-1.002 1.621l-.445.223a1 1 0 1 0 .894 1.788l.446-.222a3.812 3.812 0 0 0 2.107-3.41v-6.524a3.813 3.813 0 0 0-2.108-3.41l-.445-.222a1 1 0 0 0-.894 1.788l.445.223a1.812 1.812 0 0 1 1.002 1.621v6.524Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M44.728 46.922a2.5 2.5 0 0 0 2.274-2.49v-5.434a2.5 2.5 0 0 0-2.274-2.49l-6-.545a2.5 2.5 0 0 0-2.726 2.49v6.525a2.5 2.5 0 0 0 2.726 2.49l6-.546Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M46.002 44.977c0 .686-.388 1.314-1.002 1.621l-.445.223a1 1 0 1 0 .894 1.788l.446-.222a3.812 3.812 0 0 0 2.107-3.41v-6.524a3.813 3.813 0 0 0-2.108-3.41l-.445-.222a1 1 0 0 0-.894 1.788l.445.223a1.812 1.812 0 0 1 1.002 1.621v6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M16.502 14.717a2.5 2.5 0 0 0-2.5 2.5v31a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-31a2.5 2.5 0 0 0-2.5-2.5h-15Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M16.002 48.217v-31a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v31a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5Zm-2-31a2.5 2.5 0 0 1 2.5-2.5h15a2.5 2.5 0 0 1 2.5 2.5v31a2.5 2.5 0 0 1-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5v-31Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.502 1.712h34.5l.725 7.251a2.5 2.5 0 0 1-2.487 2.749H13.502a2.5 2.5 0 0 0-2.5 2.5v33.522a2.5 2.5 0 0 1-2.835 2.478l-7.165-.97V4.212a2.5 2.5 0 0 1 2.5-2.5Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M40.002 1.715a1 1 0 0 0-1-1h-35.5a3.5 3.5 0 0 0-3.5 3.5v46.5a1 1 0 1 0 2 0v-46.5a1.5 1.5 0 0 1 1.5-1.5h35.5a1 1 0 0 0 1-1Z",
  clipRule: "evenodd"
})));
SvgRectangle53DError.viewBox = '0 0 48 52';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle53DError);
export default ForwardRef;